"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScriptsInjector = /** @class */ (function () {
    function ScriptsInjector(require) {
        this.require = require;
    }
    ScriptsInjector.prototype.inject = function (modLoader, modConfig) {
        var moduleNames = modConfig.map(function (module) {
            return module.moduleName;
        });
        this.require(moduleNames, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (args === undefined || args === null || args.length === 0) {
                modLoader.trigger("afterload", true);
                return;
            }
            moduleNames.forEach(function (mod, index) {
                if (modConfig[index].exportName !== undefined && modConfig[index].exportName !== null) {
                    modLoader.modules[modConfig[index].exportName] = args[index];
                }
            });
            modLoader.trigger("afterload", true);
        });
    };
    return ScriptsInjector;
}());
exports.ScriptsInjector = ScriptsInjector;
//# sourceMappingURL=ScriptsInjector.js.map